<template>
  <div id="app" class="official-app">
    <header-comp
      v-show="$route.path != '/special-column'"
      class="pc-comp"
    ></header-comp>
    <media-header class="mobile-comp"></media-header>
    <transition name="fade">
      <div
        class="pervasive-bag"
        :class="{
          'party-building-bag': $route.query.title == '器检党建',
          'special-column-bag': $route.path == '/special-column'
        }"
      >
        <div class="version-center mt16">
          <!-- <div class="mobile-comp" style="width: 100%; height: 58px"></div> -->
          <keep-alive
            :include="[
              'home',
              'institutionalOverview',
              'officeHall',
              'specialColumn'
            ]"
          >
            <router-view></router-view>
          </keep-alive>
        </div>
        <friendship-link></friendship-link>
      </div>
    </transition>
    <footer-comp></footer-comp>
  </div>
</template>
<script>
import headerComp from './components/header'
import mediaHeader from './components/mobile-page/mediaHeader.vue'
import footerComp from './components/footer'
import friendshipLink from './components/friendship-link.vue'

export default {
  name: 'app',
  components: {
    headerComp,
    footerComp,
    mediaHeader,
    friendshipLink
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},

  methods: {},
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
@import url(./assets/css/main.scss);
.fade-enter-active,
.fade-leave-avtive {
  animation-name: fadeInUp;
  animation-duration: 0.5s;
  animation-fill-mode: both;
  animation-timing-function: ease-in;
}
@media only screen and (min-width: 768px) {
  .mobile-comp {
    display: none;
  }
  .pc-comp {
    display: block;
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 3px, 0);
  }

  to {
    opacity: 1;
    transform: translateZ(0);
  }
}
// 基础背景
.pervasive-bag {
  position: relative;
  background: #fafcff;
  background-position: center bottom;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
}

.party-building-bag {
  background: #fceeeb url(./assets/images/img_6.webp) no-repeat;
  background-position: center bottom;
  background-size: 100% 100%;
}
.special-column-bag {
  background: red url(./assets/images/bg.webp) no-repeat;
  background-size: 100% 100%;
}
@media screen and (max-width: 768px) {
  .pervasive-bag {
    padding-top: 58px;
    background-color: #fafcff;
  }
}
</style>
